(function () {
  function updateComparePopupButtons(container) {
    if (!container) return;
    var track = container.querySelector('.compare-popup-buttons__track');
    var prev = container.querySelector('.compare-popup-buttons__arrow--prev');
    var next = container.querySelector('.compare-popup-buttons__arrow--next');
    if (!track || !prev || !next) return;

    var hasOverflow = track.scrollWidth > track.clientWidth + 1;
    var sl = track.scrollLeft;
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var atStart = !hasOverflow || sl <= 1;
    var atEnd = !hasOverflow || sl >= max - 1;

    container.classList.toggle('has-overflow', hasOverflow);
    container.classList.toggle('is-at-start', atStart);
    container.classList.toggle('is-at-end', atEnd);
    prev.classList.toggle('is-disabled', atStart);
    next.classList.toggle('is-disabled', atEnd);
    prev.setAttribute('aria-hidden', atStart ? 'true' : 'false');
    next.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
    prev.tabIndex = atStart ? -1 : 0;
    next.tabIndex = atEnd ? -1 : 0;
  }

  function scrollComparePopupBtnToCenter(btn) {
    var track = btn.closest('.compare-popup-buttons__track');
    if (!track) return;
    var buttons = track.querySelectorAll('.compare-popup-btn');
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

    if (buttons.length && btn === buttons[0]) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }
    if (buttons.length && btn === buttons[buttons.length - 1]) {
      track.scrollTo({ left: maxScroll, behavior: 'smooth' });
      return;
    }

    var btnRect = btn.getBoundingClientRect();
    var trackRect = track.getBoundingClientRect();
    var left =
      track.scrollLeft +
      (btnRect.left - trackRect.left) -
      track.clientWidth / 2 +
      btnRect.width / 2;
    track.scrollTo({ left: Math.max(0, Math.min(left, maxScroll)), behavior: 'smooth' });
  }

  function initComparePopupButtons(root) {
    if (!root) return;
    root.querySelectorAll('.compare-popup-buttons').forEach(function (container) {
      var track = container.querySelector('.compare-popup-buttons__track');
      if (!track) return;
      if (track.dataset.compareButtonsBound !== 'true') {
        track.dataset.compareButtonsBound = 'true';
        track.addEventListener(
          'scroll',
          function () {
            updateComparePopupButtons(container);
          },
          { passive: true }
        );
      }
      updateComparePopupButtons(container);
    });
  }

  function bindOpenTriggers() {
    document.querySelectorAll('.corporate-compare-btn > .btn').forEach(function (elem) {
      elem.onclick = function () {
        var parentElem = elem.parentElement;
        var modal = document.querySelector('.compare-modal');
        var popupContent = parentElem.querySelector('.corporate-compare-popup-content');
        if (!modal || !popupContent) return;
        modal.querySelector('.modal__inner').innerHTML = popupContent.innerHTML;
        document.querySelector('body').classList.add('overflow-hidden');
        modal.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          initComparePopupButtons(modal);
          setTimeout(function () {
            initComparePopupButtons(modal);
          }, 50);
        });
      };
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    var arrow = el.closest('.compare-popup-buttons__arrow');

    if (arrow) {
      e.preventDefault();
      if (arrow.classList.contains('is-disabled')) return;
      var wrap = arrow.closest('.compare-popup-buttons');
      var track = wrap && wrap.querySelector('.compare-popup-buttons__track');
      if (!track) return;
      var step = Math.max(120, Math.round(track.clientWidth * 0.6));
      track.scrollBy({
        left: arrow.classList.contains('compare-popup-buttons__arrow--next') ? step : -step,
        behavior: 'smooth',
      });
      return;
    }

    if (el.classList.contains('compare-popup-btn') || el.closest('.compare-popup-btn')) {
      e.preventDefault();
      if (!el.classList.contains('compare-popup-btn')) {
        el = el.closest('.compare-popup-btn');
      }
      var popupElem = el.closest('.modal');
      if (!popupElem) return;
      var imageIndex = el.getAttribute('data-btn-index');
      var activeBtn = popupElem.querySelector('.compare-popup-btn.active');
      var activeTable = popupElem.querySelector('.compare-popup-table-inner.active');
      var nextTable = popupElem.querySelector(
        '.compare-popup-table-inner[data-table-index="' + imageIndex + '"]'
      );
      if (activeBtn) activeBtn.classList.remove('active');
      el.classList.add('active');
      if (activeTable) activeTable.classList.remove('active');
      if (nextTable) nextTable.classList.add('active');
      scrollComparePopupBtnToCenter(el);
      return;
    }

    if (el.classList.contains('close-popup-modal') || el.closest('.close-popup-modal')) {
      e.preventDefault();
      var modal = el.closest('.modal');
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'true');
      var inner = modal.querySelector('.modal__inner');
      if (inner) inner.innerHTML = '';
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  });

  window.addEventListener('resize', function () {
    var modal = document.querySelector('.compare-modal[aria-hidden="false"]');
    if (modal) initComparePopupButtons(modal);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindOpenTriggers);
  } else {
    bindOpenTriggers();
  }
})();
